import { Site } from './site';
import { Content, Folder, Genus } from '@xanadu/model';
import { TreeAncestor } from '../core/tree-ancestor';

export class BatchContent {
    public custome: any = {};
    public aspects?: string[];

    constructor(
        public readonly genus: Genus,
        public readonly site?: Site,
        private folders?: Folder[]
    ) {
        this.setAspects();
    }

    get content(): Content {
        const content = new Content();

        content.parent = this.genus;
        content.parentId = this.genus?._id;
        content.prototype = this.genus?.prototype;
        content.prototypeId = this.genus?.prototype?._id;
        content.data = {};

        return content;
    }

    private setAspects(): void {
        if (this.folders?.length) {
            const treeAncestor = new TreeAncestor(this.folders, folder => folder._id, folder => folder instanceof Folder, folder => folder.parent);
            const folder = treeAncestor.leastCommon as Folder;
            this.aspects = (folder?.inheritAspects || []).concat(folder?.aspects || []);
        } else {
            this.aspects = [];
        }
    }

}
